import trackingService, { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import CheckboxDropdown from './CheckboxDropdown';
import InputContainer from './InputContainer';
import { SelectInputOption } from './SelectInput';

interface ICheckboxDropdownInputProps<T> {
    title: string;
    values?: T[];
    options: SelectInputOption<T>[];
    handleOptionSelect: (values: T[]) => void;
    disabled?: boolean;
    minimumSelectionLimit?: number;
    track: TrackingEvent;
}

// eslint-disable-next-line @typescript-eslint/comma-dangle
const CheckboxDropdownInput = <T,>(props: ICheckboxDropdownInputProps<T>): JSX.Element => (
    <InputContainer title={props.title}>
        <CheckboxDropdown
            values={props.values ?? []}
            options={props.options}
            handleOptionSelect={(values) => {
                props.handleOptionSelect(values);
                trackingService.track({ ...props.track, eventValue: values });
            }}
            displayValues
            disabled={props.disabled}
            minimumSelectionLimit={props.minimumSelectionLimit}
            track={props.track}
        />
    </InputContainer>
);

export default CheckboxDropdownInput;
